import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { MergePurgeParameters } from './types/merge-purge-parameters.type';
import type { SeedCountByMailCode } from './types/seed-count-by-mail-code.type';

/**
 * Retrieves the seed count grouped by mail code using the provided HTTP client instance and search parameters.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @param searchParams - The parameters for the merge-purge operation to filter the results.
 * @returns A promise that resolves to an {@link OperationResultWithData} containing an array
 * of {@link SeedCountByMailCode}.
 * @throws Throws an error if the request fails.
 */
export const getSeedCountByMailCode = async (instance: KyInstance, searchParams: MergePurgeParameters) => {
  try {
    return await instance
      .get<OperationResultWithData<SeedCountByMailCode[]>>(Uri.reports.mergePurge.seedCountByMailCode, {
        searchParams,
      })
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
